// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2i3Nn","left":"styles_left__1S2G7","right":"styles_right__1yJcJ","alert":"styles_alert__QjG-V"};